/** Curated, self-hosted Site Appearance Studio catalog. Unknown font IDs are rejected. */
export const SITE_FONTS = [
  { id: "slider-sans", label: "Slider Sans (Inter)", group: "Latin Sans", family: "'Slider Sans', system-ui, sans-serif" },
  { id: "inter", label: "Inter", group: "Latin Sans", family: "'Slider Sans', system-ui, sans-serif" },
  { id: "geist", label: "Geist", group: "Latin Sans", family: "'Site Geist', 'Slider Sans', sans-serif" },
  { id: "noto-sans", label: "Noto Sans", group: "Latin Sans", family: "'Site Noto Sans', 'Slider Sans', sans-serif" },
  { id: "nunito-sans", label: "Nunito Sans", group: "Latin Sans", family: "'Site Nunito Sans', sans-serif" },
  { id: "figtree", label: "Figtree", group: "Latin Sans", family: "'Site Figtree', sans-serif" },
  { id: "roboto", label: "Roboto", group: "Latin Sans", family: "'Site Roboto', sans-serif" },
  { id: "raleway", label: "Raleway", group: "Latin Sans", family: "'Site Raleway', sans-serif" },
  { id: "dm-sans", label: "DM Sans", group: "Latin Sans", family: "'Site DM Sans', sans-serif" },
  { id: "public-sans", label: "Public Sans", group: "Latin Sans", family: "'Site Public Sans', sans-serif" },
  { id: "outfit", label: "Outfit", group: "Latin Sans", family: "'Site Outfit', sans-serif" },
  { id: "oxanium", label: "Oxanium", group: "Latin Sans", family: "'Site Oxanium', sans-serif" },
  { id: "manrope", label: "Manrope", group: "Latin Sans", family: "'Site Manrope', sans-serif" },
  { id: "space-grotesk", label: "Space Grotesk", group: "Latin Sans", family: "'Site Space Grotesk', sans-serif" },
  { id: "montserrat", label: "Montserrat", group: "Latin Sans", family: "'Site Montserrat', sans-serif" },
  { id: "ibm-plex-sans", label: "IBM Plex Sans", group: "Latin Sans", family: "'Site IBM Plex Sans', sans-serif" },
  { id: "source-sans-3", label: "Source Sans 3", group: "Latin Sans", family: "'Site Source Sans 3', sans-serif" },
  { id: "instrument-sans", label: "Instrument Sans", group: "Latin Sans", family: "'Site Instrument Sans', sans-serif" },
  { id: "plus-jakarta-sans", label: "Plus Jakarta Sans", group: "Latin Sans", family: "'Site Plus Jakarta Sans', sans-serif" },
  { id: "open-sans", label: "Open Sans", group: "Latin Sans", family: "'Site Open Sans', sans-serif" },
  { id: "geist-mono", label: "Geist Mono", group: "Latin Mono", family: "'Site Geist Mono', ui-monospace, monospace" },
  { id: "jetbrains-mono", label: "JetBrains Mono", group: "Latin Mono", family: "'Site JetBrains Mono', ui-monospace, monospace" },
  { id: "noto-serif", label: "Noto Serif", group: "Latin Serif", family: "'Site Noto Serif', Georgia, serif" },
  { id: "roboto-slab", label: "Roboto Slab", group: "Latin Serif", family: "'Site Roboto Slab', Georgia, serif" },
  { id: "merriweather", label: "Merriweather", group: "Latin Serif", family: "'Site Merriweather', Georgia, serif" },
  { id: "lora", label: "Lora", group: "Latin Serif", family: "'Site Lora', Georgia, serif" },
  { id: "eb-garamond", label: "EB Garamond", group: "Latin Serif", family: "'Site EB Garamond', Georgia, serif" },
  { id: "instrument-serif", label: "Instrument Serif", group: "Latin Serif", family: "'Site Instrument Serif', Georgia, serif" },
  { id: "source-serif-4", label: "Source Serif 4", group: "Latin Serif", family: "'Site Source Serif 4', Georgia, serif" },
  { id: "playfair-display", label: "Playfair Display", group: "Latin Display", family: "'Site Playfair Display', Georgia, serif" },
  { id: "fraunces", label: "Fraunces", group: "Latin Display", family: "'Site Fraunces', Georgia, serif" },
  { id: "oswald", label: "Oswald", group: "Latin Display", family: "'Site Oswald', sans-serif" },
  { id: "mikhak", label: "Mikhak / میخک", group: "Persian Sans", family: "'Slider Mikhak', 'Slider Sans FA', sans-serif" },
  { id: "vazirmatn", label: "Vazirmatn / وزیرمتن", group: "Persian Sans", family: "'Site Vazirmatn', 'Slider Sans FA', sans-serif" },
  { id: "estedad", label: "Estedad / استعداد", group: "Persian Sans", family: "'Site Estedad', 'Slider Sans FA', sans-serif" },
  { id: "cairo", label: "Cairo / قاهره", group: "Persian Sans", family: "'Site Cairo', 'Slider Sans FA', sans-serif" },
  { id: "noto-sans-arabic", label: "Noto Sans Arabic", group: "Persian Sans", family: "'Site Noto Sans Arabic', 'Slider Sans FA', sans-serif" },
  { id: "samim", label: "Samim / صمیم", group: "Persian Sans", family: "'Site Samim', 'Slider Sans FA', sans-serif" },
  { id: "shabnam", label: "Shabnam / شبنم", group: "Persian Sans", family: "'Site Shabnam', 'Slider Sans FA', sans-serif" },
  { id: "sahel", label: "Sahel / ساحل", group: "Persian Sans", family: "'Site Sahel', 'Slider Sans FA', sans-serif" },
  { id: "noto-naskh-arabic", label: "Noto Naskh Arabic", group: "Persian Serif", family: "'Site Noto Naskh Arabic', serif" },
  { id: "lalezar", label: "Lalezar / لاله‌زار", group: "Persian Display", family: "'Site Lalezar', 'Slider Sans FA', sans-serif" },
] as const;

export type SiteFontId = (typeof SITE_FONTS)[number]['id'];
export const SITE_FONT_GROUPS = ['Latin Sans', 'Latin Mono', 'Latin Serif', 'Latin Display', 'Persian Sans', 'Persian Serif', 'Persian Display'] as const;
export const SITE_ACCENTS = {
  violet: { label: 'Violet', hex: '#6840cb', foreground: '#ffffff' },
  blue: { label: 'Blue', hex: '#2457bc', foreground: '#ffffff' },
  teal: { label: 'Teal', hex: '#087b72', foreground: '#ffffff' },
  emerald: { label: 'Emerald', hex: '#176e51', foreground: '#ffffff' },
  rose: { label: 'Rose', hex: '#ae355d', foreground: '#ffffff' },
  amber: { label: 'Amber', hex: '#89550c', foreground: '#ffffff' },
} as const;
export const SITE_NEUTRALS = ['olive', 'zinc', 'slate', 'stone', 'paper', 'custom'] as const;
export const SITE_RADII = ['none', 'small', 'medium', 'large', 'xl', 'custom'] as const;
export const SITE_DENSITIES = ['compact', 'comfortable', 'spacious'] as const;
export const SITE_SURFACES = ['flat', 'bordered', 'raised'] as const;
export const SITE_TYPE_SCALES = ['compact', 'balanced', 'expressive'] as const;
export const SITE_NAV_STYLES = ['soft', 'solid', 'outline'] as const;
export const SITE_NAV_ACTIVE = ['subtle', 'filled'] as const;
export const SITE_THEME_MODES = ['system', 'light', 'dark'] as const;
export const SITE_FOREGROUND_MODES = ['auto', 'custom'] as const;
export const SITE_BUTTON_STYLES = ['solid', 'soft', 'outline'] as const;
export const SITE_CONTENT_WIDTHS = ['narrow', 'default', 'wide'] as const;
export const SITE_SHUFFLE_SCOPES = ['all', 'colors', 'typography', 'layout'] as const;
export type SiteShuffleScope = (typeof SITE_SHUFFLE_SCOPES)[number];

export interface SiteAppearanceSettings {
  mode: (typeof SITE_THEME_MODES)[number];
  accent: keyof typeof SITE_ACCENTS | 'custom';
  customAccent: string;
  neutral: (typeof SITE_NEUTRALS)[number];
  customBackground: string;
  customSurface: string;
  customForeground: string;
  customMutedForeground: string;
  customButtonForeground: string;
  customBorder: string;
  textColorMode: (typeof SITE_FOREGROUND_MODES)[number];
  secondaryTextColorMode: (typeof SITE_FOREGROUND_MODES)[number];
  buttonTextColorMode: (typeof SITE_FOREGROUND_MODES)[number];
  headingFont: SiteFontId;
  bodyFont: SiteFontId;
  persianHeadingFont: SiteFontId;
  persianBodyFont: SiteFontId;
  radius: (typeof SITE_RADII)[number];
  customRadius: number;
  density: (typeof SITE_DENSITIES)[number];
  surface: (typeof SITE_SURFACES)[number];
  typeScale: (typeof SITE_TYPE_SCALES)[number];
  navStyle: (typeof SITE_NAV_STYLES)[number];
  navActive: (typeof SITE_NAV_ACTIVE)[number];
  buttonStyle: (typeof SITE_BUTTON_STYLES)[number];
  contentWidth: (typeof SITE_CONTENT_WIDTHS)[number];
  fontScale: number;
  spacingScale: number;
  shadowStrength: number;
}
export const DEFAULT_SITE_APPEARANCE: SiteAppearanceSettings = {
  mode: 'system', accent: 'violet', customAccent: '#6840cb', neutral: 'olive',
  customBackground: '#fafafa', customSurface: '#ffffff',
  customForeground: '#18181b', customMutedForeground: '#65656e',
  customButtonForeground: '#ffffff', customBorder: '#e4e4e7',
  textColorMode: 'auto', secondaryTextColorMode: 'auto', buttonTextColorMode: 'auto',
  headingFont: 'slider-sans', bodyFont: 'slider-sans',
  persianHeadingFont: 'mikhak', persianBodyFont: 'mikhak',
  radius: 'medium', customRadius: 14, density: 'comfortable', surface: 'bordered',
  typeScale: 'balanced', navStyle: 'soft', navActive: 'subtle',
  buttonStyle: 'solid', contentWidth: 'default', fontScale: 100, spacingScale: 100, shadowStrength: 45,
};
export const SITE_APPEARANCE_STORAGE_KEY = 'slider:site-appearance:v1';
export const SITE_APPEARANCE_UPDATED_EVENT = 'slider:site-appearance-updated';

function choose<T extends string>(raw: unknown, options: readonly T[], fallback: T): T {
  return typeof raw === 'string' && options.some((option) => option === raw)
    ? (raw as T) : fallback;
}
const FONT_IDS = SITE_FONTS.map((item) => item.id);
/** Accept only literal #rgb/#rrggbb; never import raw CSS functions or var(). */
export function normalizeSiteHexColor(value: unknown, fallback: string): string {
  if (typeof value !== 'string') return fallback;
  const v = value.trim();
  if (/^#[0-9a-fA-F]{6}$/.test(v)) return v.toLowerCase();
  if (/^#[0-9a-fA-F]{3}$/.test(v)) {
    return '#' + [...v.slice(1)].map((c) => c + c).join('').toLowerCase();
  }
  return fallback;
}

function clampSiteNumber(input: unknown, fallback: number, min: number, max: number, step: number): number {
  if (typeof input !== 'number' || !Number.isFinite(input)) return fallback;
  return Math.round((Math.min(max, Math.max(min, input)) - min) / step) * step + min;
}

export function siteContrastRatio(foreground: string, background: string): number {
  const luminance = (hex: string) => {
    const channels = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
    const linear = channels.map((v) => v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
    return (linear[0] ?? 0) * 0.2126 + (linear[1] ?? 0) * 0.7152 + (linear[2] ?? 0) * 0.0722;
  };
  const a = luminance(foreground), b = luminance(background);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
}

function accessibleAccentForeground(hex: string): string {
  return siteContrastRatio('#ffffff', hex) >= 4.5 ? '#ffffff' : '#17171a';
}

function mixSiteHex(a: string, b: string, fraction: number): string {
  const channel = (n: number) => Math.round(
    parseInt(a.slice(n, n + 2), 16) * (1 - fraction) + parseInt(b.slice(n, n + 2), 16) * fraction,
  ).toString(16).padStart(2, '0');
  return '#' + [1, 3, 5].map(channel).join('');
}

/** Main text must remain readable whether a custom neutral or an explicit text override is used. */
export function siteAppearanceContrastWarning(settings: SiteAppearanceSettings, systemDark = false): boolean {
  if (settings.neutral !== 'custom' && settings.textColorMode !== 'custom' &&
    settings.secondaryTextColorMode !== 'custom') return false;
  const { tokens } = resolveSiteAppearance(settings, systemDark);
  const background = tokens['--background'] ?? '#ffffff';
  const card = tokens['--card'] ?? '#ffffff';
  const text = tokens['--foreground'] ?? '#000000';
  const secondary = tokens['--muted-foreground'] ?? '#000000';
  return siteContrastRatio(text, background) < 4.5 ||
    siteContrastRatio(text, card) < 4.5 ||
    (settings.secondaryTextColorMode === 'custom' && (
      siteContrastRatio(secondary, background) < 4.5 ||
      siteContrastRatio(secondary, card) < 4.5
    ));
}

/** A manual button foreground is allowed, but its contrast issue is surfaced before Apply. */
export function siteButtonContrastWarning(settings: SiteAppearanceSettings): boolean {
  if (settings.buttonTextColorMode !== 'custom' || settings.buttonStyle !== 'solid') return false;
  const accent = settings.accent === 'custom' ? settings.customAccent : SITE_ACCENTS[settings.accent].hex;
  return siteContrastRatio(settings.customButtonForeground, accent) < 4.5;
}

const PERSIAN_FONT_IDS = SITE_FONTS.filter((item) => item.group.startsWith('Persian'))
  .map((item) => item.id);

export function sanitizeSiteAppearance(raw: unknown): SiteAppearanceSettings {
  const data = raw && typeof raw === 'object' && !Array.isArray(raw)
    ? raw as Record<string, unknown> : {};
  return {
    mode: choose(data.mode, SITE_THEME_MODES, DEFAULT_SITE_APPEARANCE.mode),
    accent: choose(data.accent, [...(Object.keys(SITE_ACCENTS) as Array<keyof typeof SITE_ACCENTS>), 'custom' as const], DEFAULT_SITE_APPEARANCE.accent),
    customAccent: normalizeSiteHexColor(data.customAccent, DEFAULT_SITE_APPEARANCE.customAccent),
    customBackground: normalizeSiteHexColor(data.customBackground, DEFAULT_SITE_APPEARANCE.customBackground),
    customSurface: normalizeSiteHexColor(data.customSurface, DEFAULT_SITE_APPEARANCE.customSurface),
    customForeground: normalizeSiteHexColor(data.customForeground, DEFAULT_SITE_APPEARANCE.customForeground),
    customMutedForeground: normalizeSiteHexColor(data.customMutedForeground, DEFAULT_SITE_APPEARANCE.customMutedForeground),
    customButtonForeground: normalizeSiteHexColor(data.customButtonForeground, DEFAULT_SITE_APPEARANCE.customButtonForeground),
    textColorMode: choose(data.textColorMode, SITE_FOREGROUND_MODES, DEFAULT_SITE_APPEARANCE.textColorMode),
    secondaryTextColorMode: choose(data.secondaryTextColorMode, SITE_FOREGROUND_MODES, DEFAULT_SITE_APPEARANCE.secondaryTextColorMode),
    buttonTextColorMode: choose(data.buttonTextColorMode, SITE_FOREGROUND_MODES, DEFAULT_SITE_APPEARANCE.buttonTextColorMode),
    customBorder: normalizeSiteHexColor(data.customBorder, DEFAULT_SITE_APPEARANCE.customBorder),
    neutral: choose(data.neutral, SITE_NEUTRALS, DEFAULT_SITE_APPEARANCE.neutral),
    headingFont: choose(data.headingFont, FONT_IDS, DEFAULT_SITE_APPEARANCE.headingFont),
    bodyFont: choose(data.bodyFont, FONT_IDS, DEFAULT_SITE_APPEARANCE.bodyFont),
    persianHeadingFont: choose(data.persianHeadingFont, PERSIAN_FONT_IDS, DEFAULT_SITE_APPEARANCE.persianHeadingFont),
    persianBodyFont: choose(data.persianBodyFont, PERSIAN_FONT_IDS, DEFAULT_SITE_APPEARANCE.persianBodyFont),
    radius: choose(data.radius, SITE_RADII, DEFAULT_SITE_APPEARANCE.radius),
    customRadius: clampSiteNumber(data.customRadius, DEFAULT_SITE_APPEARANCE.customRadius, 0, 36, 1),
    density: choose(data.density, SITE_DENSITIES, DEFAULT_SITE_APPEARANCE.density),
    surface: choose(data.surface, SITE_SURFACES, DEFAULT_SITE_APPEARANCE.surface),
    typeScale: choose(data.typeScale, SITE_TYPE_SCALES, DEFAULT_SITE_APPEARANCE.typeScale),
    navStyle: choose(data.navStyle, SITE_NAV_STYLES, DEFAULT_SITE_APPEARANCE.navStyle),
    navActive: choose(data.navActive, SITE_NAV_ACTIVE, DEFAULT_SITE_APPEARANCE.navActive),
    buttonStyle: choose(data.buttonStyle, SITE_BUTTON_STYLES, DEFAULT_SITE_APPEARANCE.buttonStyle),
    contentWidth: choose(data.contentWidth, SITE_CONTENT_WIDTHS, DEFAULT_SITE_APPEARANCE.contentWidth),
    fontScale: clampSiteNumber(data.fontScale, DEFAULT_SITE_APPEARANCE.fontScale, 80, 125, 5),
    spacingScale: clampSiteNumber(data.spacingScale, DEFAULT_SITE_APPEARANCE.spacingScale, 75, 135, 5),
    shadowStrength: clampSiteNumber(data.shadowStrength, DEFAULT_SITE_APPEARANCE.shadowStrength, 0, 100, 5),
  };
}
/** A new management user keeps the existing dashboard theme until they explicitly Apply.
 * A valid legacy browser preference opts in automatically, including Marketing presets. */
/** Revert the optional personalized app appearance to the original Slider chrome. */
export function clearSiteAppearance(): boolean {
  try {
    globalThis.localStorage?.removeItem(SITE_APPEARANCE_STORAGE_KEY);
    globalThis.dispatchEvent?.(new Event(SITE_APPEARANCE_UPDATED_EVENT));
    return true;
  } catch {
    return false;
  }
}

export function hasStoredSiteAppearance(): boolean {
  try {
    const value = globalThis.localStorage?.getItem(SITE_APPEARANCE_STORAGE_KEY);
    if (!value) return false;
    const parsed: unknown = JSON.parse(value);
    return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
  } catch {
    return false;
  }
}

export function readSiteAppearance(): SiteAppearanceSettings {
  try {
    const value = globalThis.localStorage?.getItem(SITE_APPEARANCE_STORAGE_KEY);
    if (value) return sanitizeSiteAppearance(JSON.parse(value) as unknown);
  } catch { /* corrupted or inaccessible storage */ }
  return { ...DEFAULT_SITE_APPEARANCE };
}
export function saveSiteAppearance(input: SiteAppearanceSettings): boolean {
  try {
    globalThis.localStorage?.setItem(SITE_APPEARANCE_STORAGE_KEY, JSON.stringify(sanitizeSiteAppearance(input)));
    globalThis.dispatchEvent?.(new Event(SITE_APPEARANCE_UPDATED_EVENT));
    return true;
  } catch { return false; }
}
export function exportSiteAppearance(input: SiteAppearanceSettings): string {
  return JSON.stringify({ version: 2, appearance: sanitizeSiteAppearance(input) }, null, 2);
}
export function importSiteAppearance(json: string): SiteAppearanceSettings {
  const parsed: unknown = JSON.parse(json);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw Error('Invalid appearance preset.');
  const record = parsed as Record<string, unknown>;
  if ((record.version !== 1 && record.version !== 2) || !record.appearance || typeof record.appearance !== 'object' || Array.isArray(record.appearance)) throw Error('Unsupported preset version.');
  return sanitizeSiteAppearance(record.appearance);
}
export function siteFontFamily(id: SiteFontId): string {
  return SITE_FONTS.find((font) => font.id === id)?.family ?? SITE_FONTS[0].family;
}

type Palette = { bg: string; fg: string; card: string; border: string; muted: string; mutedFg: string };
type StandardNeutral = Exclude<SiteAppearanceSettings['neutral'], 'custom'>;
const LIGHT: Record<StandardNeutral, Palette> = {
  olive: { bg: '#fafaf6', fg: '#252620', card: '#ffffff', border: '#e3e5dc', muted: '#f0f1e9', mutedFg: '#64675f' },
  zinc: { bg: '#fafafa', fg: '#18181b', card: '#ffffff', border: '#e4e4e7', muted: '#f4f4f5', mutedFg: '#65656e' },
  slate: { bg: '#f8fafc', fg: '#172033', card: '#ffffff', border: '#dce2eb', muted: '#eef2f7', mutedFg: '#5d6b7d' },
  stone: { bg: '#faf9f7', fg: '#25221f', card: '#ffffff', border: '#e7e3df', muted: '#f3f0ed', mutedFg: '#6c655f' },
  paper: { bg: '#fffdf8', fg: '#302b23', card: '#ffffff', border: '#ebe4d7', muted: '#f8f2e7', mutedFg: '#766c5b' },
};
const DARK: Record<StandardNeutral, Palette> = {
  olive: { bg: '#191c19', fg: '#f4f6ee', card: '#252922', border: '#41463c', muted: '#31362e', mutedFg: '#b3baaa' },
  zinc: { bg: '#17171a', fg: '#f4f4f5', card: '#242428', border: '#404047', muted: '#303035', mutedFg: '#b3b3bd' },
  slate: { bg: '#131c2a', fg: '#f0f5fb', card: '#1c293b', border: '#35435a', muted: '#253349', mutedFg: '#aebed2' },
  stone: { bg: '#1d1a18', fg: '#f7f3ee', card: '#292421', border: '#463e38', muted: '#342e28', mutedFg: '#bdb3a9' },
  paper: { bg: '#211c17', fg: '#fbf3e7', card: '#2f281f', border: '#51483a', muted: '#3b3228', mutedFg: '#c7b6a1' },
};
const RADII: Record<Exclude<SiteAppearanceSettings['radius'], 'custom'>, readonly [string, string]> = {
  none: ['0px', '0px'], small: ['4px', '7px'], medium: ['10px', '18px'],
  large: ['15px', '26px'], xl: ['22px', '36px'],
};
const DENSITY = { compact: '0.82', comfortable: '1', spacious: '1.16' } as const;
const TYPE_SCALE = { compact: '0.86', balanced: '1', expressive: '1.13' } as const;
export type SiteAppearanceTokens = Record<string, string>;
export function resolveSiteAppearance(
  settings: SiteAppearanceSettings, systemDark: boolean,
): { dark: boolean; tokens: SiteAppearanceTokens } {
  const safe = sanitizeSiteAppearance(settings);
  const dark = safe.mode === 'dark' || (safe.mode === 'system' && systemDark);
  const p = safe.neutral === 'custom'
    ? {
        bg: safe.customBackground,
        fg: safe.customForeground,
        card: safe.customSurface,
        border: safe.customBorder,
        muted: mixSiteHex(safe.customBackground, safe.customForeground, dark ? 0.19 : 0.065),
        mutedFg: mixSiteHex(safe.customForeground, safe.customBackground, 0.35),
      }
    : (dark ? DARK : LIGHT)[safe.neutral];
  const accent = safe.accent === 'custom' ? safe.customAccent : SITE_ACCENTS[safe.accent].hex;
  const foreground = safe.textColorMode === 'custom' ? safe.customForeground : p.fg;
  const mutedForeground = safe.secondaryTextColorMode === 'custom' ? safe.customMutedForeground : p.mutedFg;
  const onAccent = safe.buttonTextColorMode === 'custom'
    ? safe.customButtonForeground : accessibleAccentForeground(accent);
  const [controlRadius, panelRadius] = safe.radius === 'custom'
    ? [Math.max(0, safe.customRadius - 4) + 'px', safe.customRadius + 'px'] as const
    : RADII[safe.radius];
  const shadowOpacity = safe.shadowStrength / 100;
  const shadow = safe.surface === 'flat' || shadowOpacity === 0 ? 'none'
    : safe.surface === 'raised'
      ? '0 16px 40px rgba(9,9,21,' + (0.28 * shadowOpacity).toFixed(3) + ')'
      : '0 5px 18px rgba(9,9,21,' + (0.15 * shadowOpacity).toFixed(3) + ')';
  return { dark, tokens: {
    '--background': p.bg, '--foreground': foreground,
    '--card': p.card, '--card-foreground': foreground, '--popover': p.card,
    '--popover-foreground': foreground, '--secondary': p.muted, '--secondary-foreground': foreground,
    '--muted': p.muted, '--muted-foreground': mutedForeground,
    '--accent': p.muted, '--accent-foreground': foreground, '--border': p.border, '--input': p.border,
    '--primary': accent, '--primary-foreground': onAccent, '--ring': accent,
    '--v2-violet': accent, '--site-accent': accent,
    // The solid navigation surface is accent-tinted, while soft/outline stay neutral.
    '--site-nav-background': mixSiteHex(accent, p.card, dark ? 0.77 : 0.87),
    '--site-body-font': siteFontFamily(safe.bodyFont),
    '--site-heading-font': siteFontFamily(safe.headingFont),
    '--site-persian-font': siteFontFamily(safe.persianBodyFont),
    '--site-persian-heading-font': siteFontFamily(safe.persianHeadingFont),
    '--site-type-scale': String(Number(TYPE_SCALE[safe.typeScale]) * safe.fontScale / 100),
    '--site-density-factor': String(Number(DENSITY[safe.density]) * safe.spacingScale / 100),
    '--site-control-radius': controlRadius, '--site-panel-radius': panelRadius,
    '--site-shadow': shadow,
    '--site-container-width': safe.contentWidth === 'narrow' ? '980px' : safe.contentWidth === 'wide' ? '1440px' : '1200px',
    '--site-button-background': safe.buttonStyle === 'outline' ? 'transparent'
      : safe.buttonStyle === 'soft' ? mixSiteHex(accent, p.card, 0.85) : accent,
    '--site-button-foreground': safe.buttonStyle === 'outline' ? accent
      : safe.buttonStyle === 'soft' ? foreground : onAccent,
    '--site-button-border': safe.buttonStyle === 'outline' ? accent : 'transparent',
  }};
}
